import type { EpocusReview } from "$global-providers/rxdb-provider/collections/epocus-review";
import { Box, Button, Typography } from "@material-ui/core";
import { useState } from "react";
import {
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_SECONDARY,
  EPOCUS_WHITE,
  rem,
} from "../../../_lib/epocus-palette";
import { EpocusStarRating } from "../../../_lib/epocus-star-rating";
import { ImageQualityDefinitions } from "../../../_lib/image-quality-definitions";

/**
 * The one change a signed review takes: its reviewer correcting the image
 * quality score, which is what returns a non-diagnostic study to billing.
 */
export const RescoreReview: FC<{
  review: EpocusReview;
  saving: boolean;
  onSave: (score: number) => void;
}> = ({ review, saving, onSave }) => {
  const stored = review.imageQualityScore ?? review.qualityScore;
  const [score, setScore] = useState(stored);
  const unchanged = score === stored || score < 1;

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
      <Typography style={{ fontSize: rem(13), color: EPOCUS_TEXT_SECONDARY }}>
        Change the image quality score if it was wrong. A score of 1 or 2 keeps
        the study out of billing.
      </Typography>
      <EpocusStarRating value={score} onChange={setScore} wholeStarsOnly />
      <ImageQualityDefinitions value={score} />
      <Button
        variant="contained"
        disableElevation
        disabled={unchanged || saving}
        onClick={() => onSave(score)}
        style={{
          alignSelf: "flex-start",
          textTransform: "none",
          fontWeight: 700,
          color: EPOCUS_WHITE,
          backgroundColor: EPOCUS_PRIMARY,
          opacity: unchanged || saving ? 0.4 : 1,
        }}
      >
        Save score
      </Button>
    </Box>
  );
};
